<template>
  <!-- 关联展品 弹窗 -->
    <winDialog
      :dialogShow.sync="dShow"
      :title="$t('Combine products')"
      :subTitle="$t('Combine products description')"
      :sure="combineProduct"
      :cancel="resetKeyword"
    >
      <template v-slot:bodyContent>
        <el-form :inline="true" class="product-search-form">
          <el-form-item style="margin-bottom: 0px;">
            <el-input
              v-model="searchKeyword"
              size="mini"
              class="input__product-name"
              :placeholder="$t('Please enter product name for searching')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 0px;">
            <el-button type="primary" style="width: 90px;" size="mini" @click="search">{{ $t('homes.searchPlaceHolder') }}</el-button>
          </el-form-item>
          <el-form-item class="form-item-cascader">
            <el-cascader
                v-model="questionVal"
                size="mini"
                :props='{
                    label: "aliasName",
                    value: "id",
                    multiple: true
                }'
                clearable
                :options="questionOption" class="input__product-name2"
                :placeholder="$t('Please select product tag')"
                @change="questionTagChange"></el-cascader>
          </el-form-item>
        </el-form>
        <div class="product-table-wraper" v-loading="loading">
          <el-table
            :data="productList"
            ref="productTable"
            stripe
            @row-click="handleCurrentChange"
            :header-cell-style="{ background: '#FAFAFA' }"
            class="product-table"
          >
            <el-table-column width="30">
              <template slot-scope="scope">
                <div>
                <template v-if="multiple">
                    <el-checkbox v-model="productId" :label="scope.row.productId" class="label__productId"></el-checkbox>
                </template>
                <template v-else>
                    <el-radio v-model="productId" :label="scope.row.productId" class="label__productId"></el-radio>
                </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="120" :label="$t('hm.hProductImgVideo2')">
              <template slot-scope="scope">
                <div class="product-info">
                  <img v-lazy="$funcs.compressImage(scope.row.iconUrl.split(',')[0], 64, 64)" class="lazy-img-fadein" />
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('hm.productName')">
              <template slot-scope="scope">
                {{ $store.getters.language === 'zh' ? scope.row.productName : scope.row.pdtEName }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('Product tags')">
              <template slot-scope="scope">
                {{ scope.row.tagName ? scope.row.tagName.join(" ") : '--'}}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          background
          :hide-on-single-page="true"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="goPage"
        >
        </el-pagination>
      </template>
    </winDialog>
</template>
<script>
import winDialog from '@/components/dialog/dialog'
import questionCascader from '@/mixins/questionCascader.js'
import { getProducts } from '@/api/index'

export default {
  name: 'SelectProduct',
  props: {
    exhibitorId: {
      type: String
    },
    dialogShow: {
      type: Boolean
    },
    multiple: {
      type: Boolean,
      default: false
    },
    productId: {
      type: [Array, String],
      default: ''
    },
    productArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      searchKeyword: '',
      productList: [],
      pagination: {
        pageSize: 4,
        total: 0,
        currentPage: 1
      },
      selectedList: this.multiple ? [] : {},
      loading: false,
      ids: [],
    }
  },
  computed: {
    dShow: {
        get() {
            return this.dialogShow
        },
        set(val) {
            this.$emit("update:dialogShow", val)
        }
    }
  },
  mixins: [questionCascader],
  components: {
    winDialog
  },
  mounted() {
    this.getList()
  },
  methods: {
    varInit() {
        // this.productId = this.multiple ? [] : ''
        this.selectedList = this.multiple ? [] : {}
    },
    resetKeyword(cb) {
      this.varInit()
      cb()
      this.$emit('cancel')
    },
    combineProduct(cb) {
      if (!this.productId) {
        this.$notify.warning(this.$t('Please select a product'))
        return
      }
      this.$emit('sure', () => {
        this.resetKeyword(cb)
      })
    },
    getList() {
      let pageInfo = {
        pageRows: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
        searchKeywords: this.searchKeyword,
        showType: 'PRODUCT_LIST',
        questionList: this.searchQestionVal
      }
      this.loading = true
      getProducts(pageInfo)
        .then(res => {
          this.pagination.total = res.data.data.total
          this.pagination.currentPage = res.data.data.pageNum
          this.productList = res.data.data.list
        })
        .finally(() => {
          this.loading = false
        })
    },
    search() {
      this.pagination.currentPage = 1
      this.getList()
    },
    goPage(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    unique(arr) {
      return Array.from(new Set(arr))
    },
    
    handleCurrentChange(val) {
      if (val) {
        // let ids = []
        if (this.multiple) {
            let index = this.productArr.findIndex(item => {
                return val.productId === item.productId
            })
            if (index == -1) {
              if(this.productArr.length >= 6) {
                this.$notify({
                  title: this.$t('tips'),
                  message: this.$t('You can choose up to six exhibits'),
                  type: 'warning'
                });
                return
              } else {
                  this.ids.push(val.productId)
                  this.productArr.push(val)
              }
            } else {
              this.ids.splice(index,1)
              this.productArr.splice(index,1)
            }
            var idsArr;
            idsArr = this.unique(this.ids)
            this.$emit("update:productId", idsArr)
            
        } else {
            this.selectedList = val
            this.$emit("update:productId", val.productId)
        }
      }
      if(this.multiple) {
        this.$emit("current-change", val, this.productArr)
      } else {
        this.$emit("current-change", val, this.selectedList)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.input__product-name
  width 540px
.form-item-cascader
  display: block
  >>> .el-form-item__content
    width: 100%
.input__product-name2
  width 100%
.product-search-form
  margin 0 auto
.product-table-wraper
  max-height 400px
  overflow-y scroll
.product-table
  margin 0 auto
  width 100%
  .label__productId >>> .el-radio__label,
  .label__productId >>> .el-checkbox__label
    display none
  .el-table__row > td,
  >>> &.el-table th
    padding 6px 0
  >>> &.el-table tbody tr > td:first-child .cell {
    position relative
    &:before {
        content ''
        position absolute
        left 0
        top 0
        height 100%
        width 100%
        z-index 10
    }
  }
  &.el-table:before
    height 0px
.product-info
  display flex
  align-items flex-start
  justify-content space-between
  img
    width 64px
    height 64px
  .description
    width 500px
    height 66px
    overflow hidden
>>> .el-pagination
  margin-top 20px
  text-align center
</style>
